// extracted by mini-css-extract-plugin
module.exports = {"root":"c6e8ba5398--root--3fFvU","description":"c6e8ba5398--description--34WSl","button":"c6e8ba5398--button--2zbMw","show-all-link":"c6e8ba5398--show-all-link--3NQva"};